
document.querySelectorAll( 'img[loading=lazy]' ).forEach( image => {
    if ( image.complete ) return;

    const endOpacity = getComputedStyle( image ).opacity;

    image.addEventListener( 'load', imageLoadHandler, { once: true } );

    image.classList.add( 'is-loading' );

    function imageLoadHandler( e ) {
        image.classList.remove( 'is-loading' );
        image.animate( {
            opacity: [0, Number( endOpacity )]
        }, 600 );
    }
} );